import { Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useModal, usePage, useResource, useToast } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { APIS, SF_COMN_CD_MGMT_MSTR_INFO, URLS } from "./services/OsciComnCdAppService";
import { useEffect } from "react";

/*
 * Common Code Registration
 * !== 공통 코드 등록 ==!
 */
export const OSCI0109002S = (props: any) => {
    const {} = usePage({
        auth: ["auth_osci0003"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const toast = useToast();
    const [params] = useSearchParams();
    const bsopClsfCd = params.get("bsopClsfCd");

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "OSC0088" }],
    });

    const form = {
        comnCdMgmtMstrInfo: useForm({
            defaultSchema: SF_COMN_CD_MGMT_MSTR_INFO,
        }),
    };

    const fetch = {
        // Common Code Duplicate Check !== 공통 코드 중복 체크 ==!
        getComnCdMstrInfo: useFetch({
            api: (data: any) => APIS.getComnCdMstrInfo(data),
            enabled: false,
            onSuccess: (data) => {
                if (data.comnCdMstr.content) {
                    form.comnCdMgmtMstrInfo.setError("comnCd", {
                        message: "msg.osc.00189", // The same common codes exist. !== 동일한 공통 코드가 존재합니다. ==!
                        type: "error",
                    });
                } else {
                    form.comnCdMgmtMstrInfo.clearErrors("comnCd");
                }
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        // Save Common Code !== 공통 코드 저장 ==!
        saveComnCdMstr: useFetch({
            api: (data: any) => APIS.saveComnCdMstr(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00069", // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                    close: false,
                    onConfirm: () => {
                        navigate(URLS.osci0109003q + "/" + form.comnCdMgmtMstrInfo.getValue("comnCd"));
                    },
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00035" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),
    };

    const handler = {
        // Common Code Duplicate Check !== 공통 코드 중복 체크 ==!
        getComnCdMstrInfo: () => {
            const comnCd = form.comnCdMgmtMstrInfo.getValue("comnCd");
            if (comnCd) {
                fetch.getComnCdMstrInfo.fetch(comnCd);
            } else {
                form.comnCdMgmtMstrInfo.clearErrors("comnCd");
            }
        },
        // Save Common Code !== 공통 코드 저장 ==!
        saveComnCdMstr: () => {
            if (!comnUtils.isEmpty(form.comnCdMgmtMstrInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.comnCdMgmtMstrInfo.handleSubmit(
                () => {
                    const data = form.comnCdMgmtMstrInfo.getValues();
                    modal.openModal({
                        content: "msg.osc.00090", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.saveComnCdMstr.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
    };

    useEffect(() => {
        // Service Category 는 고정값이므로 수정할 수 없도록 한다.
        form.comnCdMgmtMstrInfo.setEditable("bsopClsfCd", false);

        if (bsopClsfCd) {
            form.comnCdMgmtMstrInfo.setValue("bsopClsfCd", bsopClsfCd);
            form.comnCdMgmtMstrInfo.setSchema("bsopClsfCd", { readOnly: true, disabled: true });
        }
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.comnCdMgmtMstrInfo.schema.comnCd}
                                onBlur={() => {
                                    handler.getComnCdMstrInfo();
                                }}
                            />
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.bsopClsfCd} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.comnCdNmEn} />
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.comnCdNmTz} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.comnCdNmKo} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.comnCdDataLenVal} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button
                        role={"list"}
                        onClick={() => {
                            if (bsopClsfCd) {
                                navigate(`${URLS.osci0109001q}?bsopClsfCd=${bsopClsfCd}`);
                            } else {
                                navigate(URLS.osci0109001q);
                            }
                        }}
                    />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.saveComnCdMstr} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
